import { Menu, ALIGNMENT } from 'ui/menu';
import { IconButton, BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { Help } from 'ui/icons';
import { WORKFLOWS_ACADEMY_URL, WORKFLOWS_DOCUMENTATION_URL } from 'modules/workflows';

const MENU_OPTIONS = [
  { label: 'Documentation', id: 'Documentation' },
  { label: 'Iterable Academy', id: 'Iterable Academy' },
  { label: 'Navigation tips', id: 'Navigation tips' },
];

export const HelpMenu = ({
  size = BUTTON_SIZES.LARGE,
  variant = BUTTON_VARIANTS.GHOSTINVERTED,
  onNavigationTips,
}: {
  size: BUTTON_SIZES;
  variant: BUTTON_VARIANTS;

  onNavigationTips: () => void;
}) => {
  const handleSelectionChange = (selection: string) => {
    switch (selection) {
      case 'Documentation':
        window.open(WORKFLOWS_DOCUMENTATION_URL);
        break;
      case 'Iterable Academy':
        window.open(WORKFLOWS_ACADEMY_URL);
        break;
      case 'Navigation tips':
        onNavigationTips();
        break;
      default:
        break;
    }
  };
  return (
    <Menu
      horizontalAlignment={ALIGNMENT.RIGHT}
      verticalAlignment={ALIGNMENT.DOWN}
      options={MENU_OPTIONS}
      id="wf-help-menu"
      handleSelectionChange={handleSelectionChange}
    >
      <IconButton size={size} variant={variant} data-test={'wf-help-menu-button'}>
        <Help height={24} width={24} isColorInherited />
      </IconButton>
    </Menu>
  );
};
